import { useState } from "react";
import * as React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import axios from "axios";
import { showSuccessToast, showErrorToast } from "../../Utils/toastUtils";
import { styled } from "@mui/system";
import Spinner, { DotLoader } from "react-spinner-overlay";

// import DeleteIcon from "@mui/icons-material/Delete";
import TablePagination, {
  tablePaginationClasses as classes,
} from "@mui/base/TablePagination";

import { useNavigate } from "react-router";

const NewFeedModal = (props) => {
  let navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [name, setName] = useState("");
  const [url, setUrl] = useState("");
  const [async, setAsync] = useState("Yes");
  const [feedType, setFeedType] = useState("MRSS");
  const [repeats, setRepeats] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [durationFilterMin, setDurationFilterMin] = useState("");
  const [durationFilterMax, setDurationFilterMax] = useState("");
  const [sizeFilter, setSizeFilter] = useState("");
  const [rows, setRows] = React.useState([]);
  const [filterSaved, setFilterSaved] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const handleFormData = () => {
    if (name.length === 0) {
      showErrorToast("Input title");
      return false;
    }
    if (url.length === 0) {
      showErrorToast("Input Youtube Feed URL");
      return false;
    }
    const pattern =
      /^https?:\/\/www\.youtube\.com\/feeds\/videos\.xml\?channel_id=[a-zA-Z0-9_-]+$/;

    if (!pattern.test(url)) {
      showErrorToast("Invalid Youtube Feed URL");
      return false;
    }
    return true;
  };

  const getData = () => {
    setLoading(true);
    console.log("getting the videos");
    let data = axios
      .post(
        "/api/feeds/info",
        { rssLink: url },
        {
          headers: {
            Authorization: "Bearer " + sessionStorage.getItem("userToken"),
          },
        }
      )
      .then((response) => {
        // Handle successful response
        console.log(response.data);
        setRows(response.data);
      })
      .catch((error) => {
        // Handle error
        console.error(error);
      })
      .finally(() => {
        setLoading(false); // Set the loading state to false after the data is loaded or an error occurs
        // setModal3(true);
      });
  };
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    showSuccessToast(
      `Rows Per Page changed to ${parseInt(event.target.value, 10)}`
    );
    setPage(0);
  };
  const blue = {
    200: "#A5D8FF",
    400: "#3399FF",
  };

  const grey = {
    50: "#F3F6F9",
    100: "#E7EBF0",
    200: "#E0E3E7",
    300: "#CDD2D7",
    400: "#B2BAC2",
    500: "#A0AAB4",
    600: "#6F7E8C",
    700: "#3E5060",
    800: "#2D3843",
    900: "#1A2027",
  };

  const Root = styled("div")(
    ({ theme }) => `
    table {
      font-family: IBM Plex Sans, sans-serif;
      font-size: 0.875rem;
      border-collapse: collapse;
      width: 100%;
    }
  
    td,
    th {
      border: 1px solid ${
        theme.palette.mode === "dark" ? grey[800] : grey[200]
      };
      text-align: left;
      padding: 6px;
    }
  
    th {
      background-color: ${
        theme.palette.mode === "dark" ? grey[900] : grey[100]
      };
    }
    `
  );

  const CustomTablePagination = styled(TablePagination)(
    ({ theme }) => `
    & .${classes.spacer} {
      display: none;
    }
  
    & .${classes.toolbar}  {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
  
      @media (min-width: 768px) {
        flex-direction: row;
        align-items: center;
      }
    }
  
    & .${classes.selectLabel} {
      margin: 0;
    }
  
    & .${classes.select}{
      padding: 2px;
      border: 1px solid ${
        theme.palette.mode === "dark" ? grey[800] : grey[200]
      };
      border-radius: 50px;
      background-color: transparent;
  
      &:hover {
        background-color: ${
          theme.palette.mode === "dark" ? grey[800] : grey[50]
        };
      }
  
      &:focus {
        outline: 1px solid ${
          theme.palette.mode === "dark" ? blue[400] : blue[200]
        };
      }
    }
  
    & .${classes.displayedRows} {
      margin: 0;
  
      @media (min-width: 768px) {
        margin-left: auto;
      }
    }
  
    & .${classes.actions} {
      padding: 2px;
      border: 1px solid ${
        theme.palette.mode === "dark" ? grey[800] : grey[200]
      };
      border-radius: 50px;
      text-align: center;
    }
  
    & .${classes.actions} > button {
      margin: 0 8px;
      border: transparent;
      border-radius: 2px;
      background-color: transparent;
  
      &:hover {
        background-color: ${
          theme.palette.mode === "dark" ? grey[800] : grey[50]
        };
      }
  
      &:focus {
        outline: 1px solid ${
          theme.palette.mode === "dark" ? blue[400] : blue[200]
        };
      }
    }
    `
  );

  const handleAsyncChange = (e) => {
    setAsync(e.target.value);
    if (e.target.value === "No") {
      setRepeats("");
    }
  };

  const submit = (e) => {
    setIsProcessing(true);
    e.preventDefault();
    if (!handleFormData()) {
      return;
    }

    const formData = {
      title: name,
      type: feedType,
      rssLink: url,
      autoSync: async,
      repeats: repeats,
      filterDurationMin: durationFilterMin,
      filterDurationMax: durationFilterMax,
      filterSize: sizeFilter,
    };
    console.log(formData);

    axios
      .post("/api/feeds/create", formData, {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("userToken"),
        },
      })
      .then((response) => {
        console.log(response);
        props.getData();
        showSuccessToast(
          response.data && response.data.Message
            ? response.data.Message
            : "Success"
        );
        props.setModal(!props.modal);
      })
      .catch((err) => {
        console.log(err);
        showErrorToast("Registration Error!");
        props.setModal(!props.modal);
      })
      .finally(() => {
        props.getData();
        setIsProcessing(false);
      });
  };

  const createFilters = () => {
    getData();
    setModal1(true);
  };

  const handleFiltersSubmit = (e) => {
    e.preventDefault();
    // console.log("Duration:", durationFilter);
    console.log("Size:", sizeFilter);
    setFilterSaved(true);
    setModal1(false);
  };

  const clearModalData = () => {
    console.log("clearing data");
    setAsync("Yes");
    setDurationFilterMin("");
    setDurationFilterMax("");
    setRepeats("");
    setSizeFilter("");
    setUrl("");
    setName("");
    setFilterSaved("");
  };

  return (
    <div>
      <Modal
        size="lg"
        backdropClassName=""
        isOpen={modal1}
        toggle={() => setModal1(!modal1)}
      >
        <ModalHeader toggle={() => setModal1(!modal1)}>
          Create Filter
        </ModalHeader>
        <ModalBody>
          <form onSubmit={handleFiltersSubmit}>
            <div>
              <div className="card card-plain">
                <div className="card-body">
                  <div className="input-group input-group-outline mb-3 d-flex justify-content-center align-items-center">
                    <label className="mt-2 mx-2 lead col-lg-2">
                      Minimum Duration:{" "}
                    </label>
                    <input
                      type="text"
                      className="form-control w-50"
                      placeholder="Duration in Min"
                      value={durationFilterMin}
                      onChange={(e) => setDurationFilterMin(e.target.value)}
                      required
                    />
                  </div>

                  <div className="input-group input-group-outline mb-3 d-flex justify-content-center align-items-center">
                    <label className="mt-2 mx-2 lead col-lg-2">
                      Maximum Duration:{" "}
                    </label>
                    <input
                      type="text"
                      className="form-control w-50"
                      placeholder="Duration in Min"
                      value={durationFilterMax}
                      onChange={(e) => setDurationFilterMax(e.target.value)}
                      required
                    />
                  </div>
                  <div className="input-group input-group-outline mb-3 d-flex justify-content-center align-items-center">
                    <label className="mt-2 mx-2 lead col-lg-2">Size: </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Size in MB"
                      value={sizeFilter}
                      onChange={(e) => setSizeFilter(e.target.value)}
                      required
                    />
                  </div>
                  <Root sx={{ width: 1500, maxWidth: "100%" }}>
                    {loading ? (
                      <div class="d-flex justify-content-center m-3">
                        <DotLoader
                          visible={loading}
                          textContent={"Loading..."}
                          animation="grow"
                          overlayColor="rgba(0, 0, 0, 0.5)"
                          color="#5BC0F8"
                        />
                      </div>
                    ) : (
                      <table aria-label="custom pagination table">
                        <thead>
                          <tr>
                            <th style={{ width: "5%" }} className="text-center">
                              Sr No.
                            </th>
                            {/* <th style={{ width: '25%' }} className="text-center">Thumbnail</th> */}
                            <th
                              style={{ width: "25%" }}
                              className="text-center"
                            >
                              Name
                            </th>
                            <th
                              style={{ width: "15%" }}
                              className="text-center"
                            >
                              Duration
                            </th>
                            <th
                              style={{ width: "15%" }}
                              className="text-center"
                            >
                              Size
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {(rowsPerPage > 0
                            ? rows
                                .filter((row) => {
                                  const durationInMinutesMin =
                                    row.duration / 60; // Convert seconds to minutes
                                  const durationInMinutesMax =
                                    row.duration / 60; // Convert seconds to minutes
                                  const sizeInMB = row.size / (1024 * 1024); // Convert KB to MB

                                  return (
                                    (durationFilterMin === "" ||
                                      durationInMinutesMin >=
                                        durationFilterMin) &&
                                    (sizeFilter === "" ||
                                      sizeInMB <= sizeFilter) &&
                                    (durationFilterMax === "" ||
                                      durationInMinutesMax <= durationFilterMax)
                                  );
                                })
                                .slice(
                                  page * rowsPerPage,
                                  page * rowsPerPage + rowsPerPage
                                )
                            : rows
                          ).map((row, index) => (
                            <tr key={row._id}>
                              <td>{index + 1}</td>
                              <td style={{ width: "20%" }}>
                                {row.name ? row.name : "No Title"}
                              </td>
                              <td style={{ width: "20%" }}>
                                {row.duration
                                  ? Math.floor(row.duration / 60) +
                                    " mins " +
                                    (row.duration % 60) +
                                    " sec"
                                  : "No Duration Found"}
                              </td>
                              <td style={{ width: "20%" }}>
                                {row.size
                                  ? Math.round(row.size / (1024 * 1024)) + " MB"
                                  : "Size undefined"}
                              </td>
                            </tr>
                          ))}
                          {emptyRows > 0 && (
                            <tr style={{ height: 34 * emptyRows }}>
                              <td colSpan={3} />
                            </tr>
                          )}
                        </tbody>
                        <tfoot>
                          <tr>
                            <CustomTablePagination
                              rowsPerPageOptions={[
                                5,
                                10,
                                25,
                                { label: "All", value: -1 },
                              ]}
                              colSpan={3}
                              count={
                                rows.filter((row) => {
                                  const durationInMinutesMin =
                                    row.duration / 60; // Convert seconds to minutes
                                  const durationInMinutesMax =
                                    row.duration / 60; // Convert seconds to minutes
                                  const sizeInMB = row.size / (1024 * 1024); // Convert KB to MB

                                  return (
                                    (durationFilterMin === "" ||
                                      durationInMinutesMin >=
                                        durationFilterMin) &&
                                    (sizeFilter === "" ||
                                      sizeInMB <= sizeFilter) &&
                                    (durationFilterMax === "" ||
                                      durationInMinutesMax <= durationFilterMax)
                                  );
                                }).length
                              }
                              rowsPerPage={rowsPerPage}
                              page={page}
                              slotProps={{
                                select: {
                                  "aria-label": "rows per page",
                                },
                                actions: {
                                  showFirstButton: true,
                                  showLastButton: true,
                                },
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                          </tr>
                        </tfoot>
                      </table>
                    )}
                  </Root>
                  <div className="text-center">
                    <button
                      type="submit"
                      className="btn bg-gradient-info my-5 mb-2"
                    >
                      Save Filters
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ModalBody>
      </Modal>

      <Modal
        size="lg"
        backdropClassName=""
        isOpen={props.modal}
        toggle={() => props.setModal(!props.modal)}
        onClosed={() => clearModalData()}
      >
        <ModalHeader toggle={() => props.setModal(!props.modal)}>
          Create Feed
        </ModalHeader>
        <ModalBody>
          <form>
            <div>
              <div className="card card-plain">
                <div className="card-body">
                  <div className="input-group input-group-outline mb-3 d-flex justify-content-center align-items-center">
                    <label className="mt-2 lead col-lg-3">Name: </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Name"
                      onChange={(e) => setName(e.target.value)}
                      required
                    />
                  </div>
                  <div className="input-group input-group-outline mb-3 d-flex justify-content-center align-items-center">
                    <label className="mt-2 lead col-lg-3">Feed Purpose: </label>
                    <input
                      type="text"
                      placeholder="URL"
                      className="form-control"
                      value={"Video Upload"}
                      disabled
                    />
                  </div>
                  <div className="input-group input-group-outline mb-3 d-flex justify-content-center align-items-center">
                    <label className="mt-2 lead col-lg-3">Feed URL: </label>
                    <input
                      type="url"
                      placeholder="URL"
                      className="form-control"
                      onChange={(e) => setUrl(e.target.value)}
                      required
                    />
                  </div>
                  <div className="input-group input-group-outline mb-3 d-flex justify-content-center align-items-center">
                    <label className="mt-2 lead col-lg-3">Feed Type: </label>
                    <input
                      type="text"
                      className="form-control"
                      // aria-label="Default select example"
                      // onChange={(e) => setFeedType(e.target.value)}
                      value="MRSS"
                      disabled
                    />
                    {/* // <option value="MRSS" selected disabled> */}
                    {/* <option value="RSS">RSS</option> */}
                  </div>
                  <div className="input-group input-group-outline mb-3 d-flex justify-content-center align-items-center">
                    <label className="mt-2 lead col-lg-3">
                      Automatically Sync:{" "}
                    </label>
                    <select
                      className="form-select p-2"
                      aria-label="Default select example"
                      value={async}
                      onChange={handleAsyncChange}
                    >
                      <option value="Yes" selected>
                        Yes
                      </option>
                      <option value="No">No</option>
                    </select>
                  </div>
                  <div className="input-group input-group-outline mb-3 d-flex justify-content-center align-items-center">
                    <label className="mt-2 lead col-lg-3">Repeats: </label>
                    <select
                      className="form-select p-2"
                      aria-label="Default select example"
                      value={repeats}
                      onChange={(e) => setRepeats(e.target.value)}
                      disabled={async === "No"}
                      required={async === "Yes"}
                    >
                      <option selected hidden>
                        {" "}
                        Select an option{" "}
                      </option>

                      <option> Every 3 Hours </option>
                      <option> Every 12 Hours </option>
                      <option> Every 24 Hours </option>
                      <option> Every 2 Days </option>
                      <option> Every 7 Days </option>
                    </select>
                  </div>
                  <div className="text-center">
                    <button
                      type="submit"
                      className="btn bg-gradient-info my-5 mb-2"
                      onClick={submit}
                      disabled={
                        !filterSaved ||
                        isProcessing ||
                        !name ||
                        !repeats ||
                        !url
                      }
                    >
                      {isProcessing ? (
                        // <p className="d-flex flex-row" >
                        <span>Processing</span>
                      ) : (
                        // </p>
                        "Create Feed"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <button
            type="button"
            className="btn bg-gradient-info my-2"
            onClick={createFilters}
          >
            Create Filters
          </button>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default NewFeedModal;
